import React from 'react';
import CreateOrder from './CreateOrder';
import { sortFiled, searchColumns } from './params';

export default (props) => <CreateOrder sortFiled={sortFiled} sortField='customerNr' sortOrder='ASC' searchColumns={searchColumns} {...props}/>;
